import logo from "images/logo-ifttt-ai-white.svg"

// Mirrors app/views/shared/_ifttt_ai_tag.html.erb (service card size).
export default function IftttAiTag() {
  return (
    <span className="ifttt-ai-tag ifttt-ai-tag-card">
      <img src={logo} alt="IFTTT.ai" width="59" height="12" />
    </span>
  )
}
